import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { PersonSocialService } from '../person-social.service';
import { PersonSocial } from '../person-social';
import { PersonService } from '@app/_components/person';

@Component({
    selector: 'app-person-social',
    templateUrl: './person-social.component.html',
    styleUrls: ['./person-social.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class PersonSocialComponent implements OnInit {
    personId: any;
    persons: any;
    socials: { value: string; name: string; }[];

	constructor(
		private personService: PersonService,
		private primengConfig: PrimeNGConfig,
		private personSocialService: PersonSocialService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.personSocial = data.personSocial,
			this.personId = data.personId,
			this.statuses = personSocialService.statuses;
			this.socials =  this.personService.socials;
	}

	@Input() personSocial: PersonSocial;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	personSocialId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'personSocialId': [],
		'type': [],
		'userName': [],
		'personId': [],
	};

	ngOnInit() {
		this.fetchPersons();
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole personSocial object
		if (this.personSocial) {
			this.personSocialId = this.personSocial.personSocialId;
			this.fixDates();
			this.form1.patchValue(this.personSocial);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.personSocialId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.form1.value.personId = this.personId;
			this.personSocialService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.personSocial = res.data.social;
						this.doAdd.emit(this.personSocial);
					},
					(err: any) => {
						console.log('personSocial-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('personSocial: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.personSocialService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.personSocial = res.data.social;
						this.doUpdate.emit(this.personSocial);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.personSocialService.delete(this.personSocial.personSocialId)
				.subscribe(
					(res: any) => {
						console.log('personSocial-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.personSocial);
					},
					(err: any) => {
						console.log('personSocial-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			personSocialId: [this.personSocialId],
			type: [],
			userName: [],
			personId: [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.personSocial.personSocialDate = moment(this.personSocial.personSocialDate).toDate();
	}
	
	fetchPersons() {
		if (!this.persons || this.persons === undefined || this.persons.length < 1) {
			try {
				this.personService.findAll()
					.subscribe(
						res => {
							console.log('findAllPersons: ' + JSON.stringify(res));
							this.persons = res.data.persons;
							return this.persons;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.persons);
		}
	}
}
